import { SupplierInvoiceStatus } from './enumerations/supplier-invoice-status.enum';
import { SupplierInvoiceItem } from './supplier-invoice-item';
import { Money } from './money';
import { SupoDocument } from '@supoui/shared/model/supo-document';

export class SupplierInvoice {
  id: number;
  caseId: number;
  supplierId: number;
  invoiceDocumentId: string;
  description: string;
  invoiceNumber: string;
  receivedDate: Date;
  invoiceDate: Date;
  dueDate: Date;
  exchangeRate: number;
  invoiceAmountLocal: Money;
  invoiceAmountExchanged: Money;
  reductionRemark: string;
  invoiceStatus: SupplierInvoiceStatus | null;
  creditorId: string;
  creditorName: string;
  serviceOrderId: string;
  items: SupplierInvoiceItem[];
  saved: number;
  settled: number;
  creditorSupplierGroup: string;
  medicalEscort: boolean;
  invoiceDocument: SupoDocument | null;
  travelAndExpensesDocuments: SupoDocument[] | null;
  medicalTravelReportDocument: SupoDocument | null;
  supoCreatedDate: Date | null;
  submittedToFinanceBridge: Date | null;
  submittedByInSupo: string | null;

  public constructor(init?: Partial<SupplierInvoice>) {
    Object.assign(this, init);
  }

  public get isRejected(): boolean {
    return this.invoiceStatus === SupplierInvoiceStatus.rejected;
  }
}
